module.exports = __webpack_public_path__ + "static/media/trailer.a784db4a.JPEG";